import Footer from '../Footer/Footer';
import { useState } from 'react';
import Sidebar from '../SidebarSection/SideBar';
import Navbar from '../Header/Navbar';
import HeruSection from './Heru Section/Heru';
import NewArrivals from './New Arrival Section/NewArrivals';
import GravitySection from './Gravity Section/Gravity';
import GiftSets from './Gift Sets Section/GiftSets';
import FeaturedSection from './Featured Section/Featured';
import ShopSection from './Shop Section/Shop';
import CartSidebar from '../Cart SideBar/CartSidebar';
import Video from './Video Section/Video';


function LandingPage() {
   const [isOpen, setIsOpen] = useState(false);
  const [isOpenHeader, setIsOpenHeader] = useState(true);
  const [cartisOpen, setcartIsOpen] = useState(false);
  // const user = useSelector((state) => state.products.userInfo);
  const [isAuthPages, setisAuthPages] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  
  const removeheader = () => {
    setIsOpenHeader(!isOpenHeader);
  };
  
  const carttoggle = () => {
      setcartIsOpen(!cartisOpen);
  };

  return (
    <div style={{display:'flex',flexDirection:"column",width:'100%'}}>
      <Navbar toggle={toggle} carttoggle={carttoggle} removeheader={removeheader} isOpenHeader={isOpenHeader}/>
      <CartSidebar isOpen={cartisOpen} toggle={carttoggle}/>
       <Sidebar isOpen={isOpen} toggle={toggle} />
      <HeruSection/>
      <NewArrivals/>
      <GravitySection/>
      <GiftSets/>
      <Video/>
      <FeaturedSection/>
      <ShopSection/>
      <Footer />
    </div>
  );
}

export default LandingPage;
